import { Capacitor } from '@capacitor/core';
import { Contacts, PhoneType, type ContactPayload } from '@capacitor-community/contacts';

/**
 * Only native builds that ship the contacts plugin. The browser, and older app binaries
 * running a newer web bundle over the air, don't have it, so they never show the picker.
 */
export const canPickDeviceContact = Capacitor.isPluginAvailable('Contacts');

export interface PickedContact {
  name: string;
  /** Mobile numbers first, without duplicates. */
  numbers: string[];
}

/** Opens the device's own contact picker. Never settles if the member cancels. */
export async function pickDeviceContact(): Promise<PickedContact> {
  const { contact } = await Contacts.pickContact({ projection: { name: true, phones: true } });
  return toPickedContact(contact);
}

export function toPickedContact(contact: ContactPayload): PickedContact {
  const name = contact.name;
  const phones = contact.phones ?? [];
  const mobilesFirst = [
    ...phones.filter((phone) => phone.type === PhoneType.Mobile),
    ...phones.filter((phone) => phone.type !== PhoneType.Mobile),
  ];

  return {
    name: name?.display?.trim() || [name?.given, name?.family].filter(Boolean).join(' '),
    numbers: [...new Set(mobilesFirst.map((phone) => phone.number?.trim()).filter((n): n is string => Boolean(n)))],
  };
}
